import { type SidebarComponent, JsonView } from '@tunasong/ui-lib'
import type { FC } from 'react'

export const SidebarEntity: FC<SidebarComponent> = ({ entity }) => <JsonView value={entity as object} />
